import type { ReactNode } from 'react';

/**
 * Rodapé de ações de uma etapa do wizard RD (Voltar + ação principal).
 *
 * Existe por um defeito medido a 375px: o rodapé era `flex flex-row ...
 * justify-between px-6` com botões `whitespace-nowrap`, e a linha não cabia —
 * "Próximo" terminava em x=411 numa janela de 375 (contêiner de 279px com
 * 363px de conteúdo) e ficava INALCANÇÁVEL, sem rolagem horizontal que o
 * revelasse. Abaixo de `sm` os filhos passam a empilhar em largura total;
 * de `sm` para cima o layout é o mesmo de antes.
 *
 * Os filhos diretos recebem `w-full` no empilhado — assim cada etapa continua
 * declarando os seus próprios botões, sem repetir classe de largura em cada um.
 */
export function StepActions({ children }: { children: ReactNode }) {
  return (
    <div className='flex flex-col items-stretch gap-3 self-stretch [&>*]:w-full sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-6 sm:px-6 sm:[&>*]:w-auto'>
      {children}
    </div>
  );
}

/**
 * Grupo de ações à direita do rodapé (Cotação: Cancelar/Recalcular/Aceitar;
 * Emissão: Imprimir/Confirmar). Mesma regra de empilhamento do `StepActions`.
 */
export function StepActionsGroup({ children }: { children: ReactNode }) {
  return (
    <div className='flex flex-col gap-3 [&>*]:w-full sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:[&>*]:w-auto'>
      {children}
    </div>
  );
}
